/* =====================================================================
   GEC — 4th of July cart rewards
   - Tracks non-gift cart spend and drives the cart-drawer progress bar.
   - Auto-adds / removes the free-gift products at each spend tier via a single
     /cart/update.js call (variant qty 1 = add, 0 = remove).
   - Reconciles on every cart mutation (Minimog cart-update event + a fetch
     backstop) and on page load, so unqualified gifts are always removed and
     qualified ones are always present. Our own update call is marked (?gec_cr=1)
     and skipped so it never loops.
   Config comes from #gec-cr-config (snippets/gec-cart-rewards.liquid).
   ===================================================================== */
(function () {
  var cfgEl = document.getElementById('gec-cr-config');
  if (!cfgEl) return;
  var CFG;
  try { CFG = JSON.parse(cfgEl.textContent); } catch (e) { return; }
  if (!CFG || !CFG.enabled) return;

  // valid gift keys/ids (skip any product that didn't resolve in Liquid)
  var GIFT_ID = {};                                  // key -> variantId
  Object.keys(CFG.gifts || {}).forEach(function (k) { var id = CFG.gifts[k].id; if (id) GIFT_ID[k] = id; });
  var ALL_IDS = Object.keys(GIFT_ID).map(function (k) { return GIFT_ID[k]; });
  if (!ALL_IDS.length) return;
  var IS_GIFT = {}; ALL_IDS.forEach(function (id) { IS_GIFT[id] = 1; });

  var TOP = CFG.top || 17500;
  var FACTOR = 1 - ((typeof CFG.discount_pct === 'number' ? CFG.discount_pct : 0) / 100); // sale % off (fallback when the cart doesn't yet reflect the discount)
  var EVT_UPDATE = (window.MinimogTheme && MinimogTheme.pubSubEvents && MinimogTheme.pubSubEvents.cartUpdate) || 'cart-update';
  var EVT_OPEN = (window.MinimogTheme && MinimogTheme.pubSubEvents && MinimogTheme.pubSubEvents.openCartDrawer) || 'open-cart-drawer';

  function money(cents) { var d = cents / 100; return '$' + (Math.round(d) === d ? d.toFixed(0) : d.toFixed(2)); }
  function ceilDollar(cents) { return '$' + Math.ceil(cents / 100); }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  // Tier qualification uses the DISCOUNTED merchandise total (what the customer actually pays after
  // the 20% sale), not the pre-discount subtotal. Gift products are $0 so they don't affect the total.
  function spendOf(cart) {
    if ((cart.total_discount || 0) > 0) return cart.total_price || 0; // cart already reflects the sale discount
    // discount not applied in the cart yet (applies at checkout) → take the configured % off the non-gift subtotal
    var full = 0;
    (cart.items || []).forEach(function (it) {
      if (!IS_GIFT[it.id]) full += (it.original_line_price != null ? it.original_line_price : it.line_price);
    });
    return Math.round(full * FACTOR);
  }
  function desiredKeys(spend) {
    var lv = (CFG.levels || []).filter(function (l) { return spend >= l.min; })[0] || { gifts: [] };
    return (lv.gifts || []).filter(function (k) { return GIFT_ID[k]; });
  }
  function currentQty(cart) {
    var q = {};
    (cart.items || []).forEach(function (it) { if (IS_GIFT[it.id]) q[it.id] = (q[it.id] || 0) + it.quantity; });
    return q;
  }

  /* ---------- progress bar ---------- */
  function bar() { return document.querySelector('[data-gec-cr]'); }
  function buildMarks(el) {
    var marks = el.querySelector('[data-gec-cr-marks]');
    if (!marks || marks.childElementCount) return;
    var ms = CFG.milestones || [];
    ms.forEach(function (m, i) {
      var node = document.createElement('div');
      node.className = 'gec-cr__mark';
      node.style.left = ((i + 1) / ms.length) * 100 + '%';   // even spacing (equal segment per tier)
      node.setAttribute('data-amt', m.amount);
      node.innerHTML = '<span class="gec-cr__dot"></span><span class="gec-cr__amt"></span><span class="gec-cr__lbl"></span>';
      node.querySelector('.gec-cr__amt').textContent = money(m.amount);
      node.querySelector('.gec-cr__lbl').textContent = m.short || m.label;
      marks.appendChild(node);
    });
  }
  // fill maps spend onto the evenly-spaced dots piecewise (reaches a dot exactly at its tier)
  function fillPct(spend) {
    var ms = CFG.milestones || []; if (!ms.length) return 0;
    var prevAmt = 0, prevPct = 0;
    for (var i = 0; i < ms.length; i++) {
      var amt = ms[i].amount, segPct = ((i + 1) / ms.length) * 100;
      if (spend < amt) { var f = amt > prevAmt ? (spend - prevAmt) / (amt - prevAmt) : 1; return prevPct + Math.max(0, Math.min(1, f)) * (segPct - prevPct); }
      prevAmt = amt; prevPct = segPct;
    }
    return 100;
  }
  function updateBar(spend) {
    var el = bar(); if (!el) return;
    el.hidden = false;
    buildMarks(el);
    var fill = el.querySelector('[data-gec-cr-fill]');
    if (fill) fill.style.width = fillPct(spend) + '%';
    var marks = el.querySelector('[data-gec-cr-marks]');
    if (marks) [].forEach.call(marks.children, function (n) {
      n.classList.toggle('is-on', spend >= parseInt(n.getAttribute('data-amt'), 10));
    });
    var msg = el.querySelector('[data-gec-cr-msg]');
    if (msg) {
      var next = (CFG.milestones || []).filter(function (m) { return spend < m.amount; })[0];
      if (next) msg.innerHTML = 'Spend <b>' + ceilDollar(next.amount - spend) + '</b> more to unlock <b>' + esc(next.label) + '</b>';
      else msg.innerHTML = "You've unlocked every free gift &mdash; nice work.";
    }
  }

  /* ---------- silent drawer refresh (no auto-open) ---------- */
  function applySections(res) {
    var drawer = document.querySelector('m-cart-drawer');
    if (!drawer || !res || !res.sections || !drawer.getSectionsToRender) return;
    drawer.getSectionsToRender().forEach(function (e) {
      var html = res.sections[e.id]; if (html == null) return;
      var target = e.selector ? drawer.querySelector(e.selector) : document.getElementById(e.id);
      if (!target) return;
      var tmp = document.createElement('div'); tmp.innerHTML = html;
      var src = e.selector ? tmp.querySelector(e.selector) : tmp;
      if (src) target.innerHTML = src.innerHTML;
    });
    if (typeof res.item_count === 'number') {
      document.querySelectorAll('.m-cart-count-bubble, .m-cart-count').forEach(function (n) { n.textContent = res.item_count; });
    }
  }

  /* ---------- reconcile ---------- */
  var running = false, again = false;
  function schedule() { if (running) { again = true; return; } reconcile(); }
  function done() { running = false; if (again) { again = false; schedule(); } }

  function reconcile() {
    running = true;
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var spend = spendOf(cart);
        updateBar(spend);
        var want = {}; desiredKeys(spend).forEach(function (k) { want[GIFT_ID[k]] = 1; });
        var cur = currentQty(cart);
        var updates = {}, changed = false;
        ALL_IDS.forEach(function (id) {
          var target = want[id] ? 1 : 0;
          if ((cur[id] || 0) !== target) { updates[id] = target; changed = true; }
        });
        if (!changed) { done(); return; }
        var body = { updates: updates };
        var drawer = document.querySelector('m-cart-drawer');
        if (drawer && drawer.getSectionsToRender) {
          var ids = []; drawer.getSectionsToRender().forEach(function (e) { if (ids.indexOf(e.id) < 0) ids.push(e.id); });
          body.sections = ids; body.sections_url = window.location.pathname;
        }
        fetch('/cart/update.js?gec_cr=1', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(body)
        })
          .then(function (r) { return r.json(); })
          .then(function (res) { applySections(res); updateBar(spendOf(res)); done(); })
          .catch(function () { done(); });
      })
      .catch(function () { done(); });
  }

  /* ---------- fetch backstop: catch every cart mutation ---------- */
  function patchFetch() {
    if (!window.fetch || window.__gecCrPatched) return;
    window.__gecCrPatched = 1;
    var _f = window.fetch;
    window.fetch = function (input) {
      var url = (typeof input === 'string') ? input : (input && input.url) || '';
      var p = _f.apply(this, arguments);
      try {
        if (typeof url === 'string' && /\/cart\/(add|change|update|clear)(\.js)?/.test(url) && url.indexOf('gec_cr') === -1) {
          p.then(function () { setTimeout(schedule, 60); }).catch(function () {});
        }
      } catch (e) {}
      return p;
    };
  }

  function boot() {
    patchFetch();
    if (window.MinimogEvents && MinimogEvents.subscribe) {
      MinimogEvents.subscribe(EVT_UPDATE, function () { schedule(); });
      MinimogEvents.subscribe(EVT_OPEN, function () { schedule(); });
    }
    schedule(); // initial: fix gifts + paint bar from current cart
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
